import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { de as deLocale } from 'date-fns/locale';
import { format, parse } from 'date-fns';

interface Props {
  label: string;
  value: string;
  onChange: (value: string) => void;
  allowEmpty?: boolean;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  testId?: string;
}

function parseMonth(value: string): Date | null {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(value)) return null;
  return parse(`${value}-01`, 'yyyy-MM-dd', new Date());
}

const MonthPicker: React.FC<Props> = ({
  label,
  value,
  onChange,
  allowEmpty = false,
  size = 'small',
  fullWidth = false,
  testId,
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
    <DatePicker
      label={label}
      views={['year', 'month']}
      openTo="month"
      format="MMMM yyyy"
      value={parseMonth(value)}
      onChange={(date) => onChange(date ? format(date, 'yyyy-MM') : '')}
      slotProps={{
        textField: {
          size,
          fullWidth,
          sx: { minWidth: fullWidth ? undefined : 210 },
          InputLabelProps: { shrink: true },
          placeholder: allowEmpty ? 'Alle Monate' : undefined,
          inputProps: { 'data-testid': testId },
        },
        field: allowEmpty
          ? { clearable: true, onClear: () => onChange('') }
          : undefined,
        actionBar: {
          actions: allowEmpty ? ['clear', 'accept'] : ['accept'],
        },
      }}
    />
  </LocalizationProvider>
);

export default MonthPicker;
